import { net_filemanage } from "@/api/http";
export const API_STFMFM01C01 = (...params) =>
net_filemanage.post("/api/STFMFM01C01", ...params)
